import { render, staticRenderFns } from "./SalariePrintReportPotvrdaOPlaci.vue?vue&type=template&id=5beed1fa&scoped=true"
import script from "./SalariePrintReportPotvrdaOPlaci.vue?vue&type=script&lang=js"
export * from "./SalariePrintReportPotvrdaOPlaci.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintReportPotvrdaOPlaci.vue?vue&type=style&index=0&id=5beed1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beed1fa",
  null
  
)

export default component.exports